import React, { useCallback, useEffect, useState } from 'react'
import Modal from 'react-responsive-modal'
import Button from '../../../../components/Button'
import Table from '../../../../components/Table'
import { getTeachersList } from '../../../../actions/common'
import { useDispatch, useSelector } from 'react-redux'
import styles from '../styles.module.scss'
import Confirmation from '../../../../components/Confirmation/Confirmation'

const PeopleModal = ({ onSubmit }) => {

  const dispatch = useDispatch()

  const [modalOpen, setModalOpen] = useState(false)
  const [selectedUser, setSelectedUser] = useState(null)
  const [confirmClose, setConfirmClose] = useState(false)

  const handleClose = useCallback(() => setConfirmClose(true), [])

  const acceptConfirmation = useCallback(() => { setModalOpen(false); setConfirmClose(false) }, [])

  const rejectConfirmation = useCallback(() => setConfirmClose(false), [])


  const { teachers } = useSelector(state => state.common)

  useEffect(() => {
    !teachers && dispatch(getTeachersList());
  }, [])

  const renderTeacherRow = (user) => (
    <tr
      key={user.mid}
      onClick={() => setSelectedUser(user)}
      className={selectedUser?.mid === user.mid && styles.activeRow}
    >
      <td>{user.calc_fio}</td>
    </tr>
  )

  const submitClickHandler = () => {
    onSubmit(selectedUser)
    setModalOpen(false)
  }

  return (
    <>
      <Button onClick={() => setModalOpen(true)}>Добавить</Button>
      <Modal
        open={modalOpen}
        onClose={handleClose}
        showCloseIcon={false}
        closeOnEsc={true}
        closeOnOverlayClick={true}
        animationDuration={1}
        classNames={{ modal: styles.peopleModal }}
        center
      >
        <Table>
          <thead>
            <tr>
              <th>Преподаватель</th>
            </tr>
          </thead>
          <tbody>
            {teachers?.map(renderTeacherRow)}
          </tbody>
        </Table>
        <div>
          <Button onClick={submitClickHandler}>Выбрать</Button>
          <Button onClick={() => setModalOpen(false)}>Закрыть</Button>
        </div>
        {confirmClose && (
          <Confirmation
            title="Закрыть без сохранения изменений?"
            acceptConfirmation={acceptConfirmation}
            rejectConfirmation={rejectConfirmation}
          />
        )}
      </Modal>
    </>
  )
}

export default PeopleModal